import config from './config/apply'
import axios from '@/utils/request'
export const applyInfoPage = params => axios.post(config.applyInfoPage, params) // 报名资料列表
export const applyPageDelete = params => axios.post(config.applyPageDelete, params) // 报名资料列表删除
export const applyPageExport = params =>
  axios.post(config.applyPageExport, params, { responseType: 'blob' }) //报名资料导出
export const applyModelDownLoad = params =>
  axios.post(config.applyModelDownLoad, params, { responseType: 'blob' }) //报名资料模板下载
export const applyUserFileImport = params => axios.post(config.applyUserFileImport, params) // 报名资料导入
export const applyUserAppendixImport = params => axios.post(config.applyUserAppendixImport, params) // 报名资料附件导入
export const applyInfoQuery = params => axios.post(config.applyInfoQuery, params) // 报名资料详情查看
export const applyInfoEdit = params => axios.post(config.applyInfoEdit, params) // 报名资料详情编辑
export const applyInfoAdd = params => axios.post(config.applyInfoAdd, params) // 报名资料详情添加
export const jobAdd = params => axios.post(config.jobAdd, params) // 新增证书和等级
export const downLoadFile = params =>
  axios.post(config.downLoadFile, params, { responseType: 'blob' }) // 下载附件
export const cardImport = params => axios.post(config.cardImport, params) // 上传pdf
export const cardImportHistory = params => axios.post(config.cardImportHistory, params) // 上传pdf历史记录
export const cardHistoryDelete = params => axios.post(config.cardHistoryDelete, params) // 上传pdf历史记录删除
export const cardListPage = params => axios.post(config.cardListPage, params) // 上传pdf准考证列表
export const cardListDelete = params => axios.post(config.cardListDelete, params) // 上传pdf准考证列表删除
export const cardUploadSingle = params => axios.post(config.cardUploadSingle, params) // 单个上传pdf准考证
export const cardInfoQueryFn = params => axios.post(config.cardInfoQueryFn, params) // 通过id查询准考证信息

export const materialsList = params => axios.post(config.materialsList, params) // 报名审核管理 审批中
export const materialsFinishList = params => axios.post(config.materialsFinishList, params) // 报名审核管理 审核完成
export const materialsListExport = params =>
  axios.post(config.materialsListExport, params, { responseType: 'blob' }) // 审批中列表导出
export const materialsFinishListExport = params =>
  axios.post(config.materialsFinishListExport, params, { responseType: 'blob' }) // 审批完成列表导出
export const batchCheck = params => axios.post(config.batchCheck, params) // 报名审核管理 批量审批
export const batchDeleteList = params => axios.post(config.batchDeleteList, params) // 报名审核管理 批量删除
export const materialsInfoQuery = params => axios.post(config.materialsInfoQuery, params) // 报名审核管理 资料详情
export const materialsInfoEdit = params => axios.post(config.materialsInfoEdit, params) // 报名审核管理 资料编辑
export const materialsCheck = params => axios.post(config.materialsCheck, params) // 报名审核管理 资料审核
export const materialsUserId = params => axios.post(config.materialsUserId, params) // 报名审核管理 查询用户id
export const applyEducationFilter = params => axios.post(config.applyEducationFilter, params) // 学历下拉列表
export const certificateMajor = params => axios.post(config.certificateMajor, params) // 证书查询专业
export const workJudge = params => axios.post(config.workJudge, params) // 工作证明判断
export const infoUpdate = params => axios.post(config.infoUpdate, params) // 信息同步
